






import Vue from 'vue'
import ForgetPassword from '../../components/auth/ForgetPassword.vue'
export default Vue.extend({
  name: "AuthForgetPassword",
  components: {
      ForgetPassword
  },
  metaInfo(){
      return  {
      title: "Reset Password - Our Nation Express",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Welome to Our Nation Express. Click the link to reset password."
        }
      ]
    };
    }
    
})
